<template>
  <CommonViewForm is-edit @reFresh="reFresh" />
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import CommonViewForm from '../../components/CommonViewForm.vue';
export default {
  name: 'BusinessPurchaseEntryInformEdit',
  components: { CommonViewForm },
  mixins: [viewMiXin],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    reFresh() {
      this.complete('BusinessPurchaseEntryInform');
    },
  },
};
</script>
